import { IScope } from 'angular'
import { STATES } from '../../../../lib/routes'
import { RegisterClosureManager } from '../../managers/register-closure-manager'
import { RegisterManager } from '../../managers/register-manager'
import { $state } from '../../ng-compat/imports'
import { CallToAction } from './types'

/**
 * Controller for the close register view where a user can summarise and submit the register closure.
 *
 * @class CloseRegisterController
 */
export class CloseRegisterController {
  public OPEN_REGISTER_STATE = STATES.OPEN_REGISTER

  /**
   * Identify whether an error occurred loading the register closure data
   */
  public isErrored = false

  /**
   * Identify when the last register closure summary is being retrieved.
   */
  public isRetrieving = true
  public registerClosure: $TSFixMe
  public callToAction: CallToAction
  constructor(
    $scope: IScope,
    private registerClosureManager: RegisterClosureManager,
    private registerManager: RegisterManager
  ) {
    'ngInject'

    this._getRegisterClosureSummary()

    this.callToAction = {
      copy: 'Switch User',
      href: '/signout?return=' + window.location.pathname,
    }

    registerManager.on('registerIdChange', this._onRegisterIdChange, this)
    $scope.$on('$destroy', () =>
      registerManager.off('registerIdChange', this._onRegisterIdChange)
    )
  }

  /**
   * Check whether current user has the permission to open or close a register
   *
   * @method hasOpenClosePermission
   */

  public hasOpenClosePermission() {
    return this.registerClosureManager.hasOpenClosePermission()
  }

  /**
   * Listen for register switching.
   *
   * @private
   * @method _onRegisterIdChange
   */
  private _onRegisterIdChange() {
    if (this.registerManager.isActiveRegisterOpen()) {
      this._getRegisterClosureSummary()
    } else {
      $state.go(this.OPEN_REGISTER_STATE)
    }
  }

  /**
   * Retrieve latest register closure summary
   *
   * @private
   * @method _getRegisterClosureSummary
   */
  private _getRegisterClosureSummary() {
    this.isRetrieving = true
    this.registerClosureManager
      .getRegisterClosureSummary()
      .then((registerClosure: $TSFixMe) => {
        this.registerClosure = registerClosure

        this.isRetrieving = false
        this.isErrored = false
      })
      .catch(() => {
        this.isRetrieving = false
        this.isErrored = true
      })
  }
}
